module.exports = __webpack_public_path__ + "static/media/profilelg.eab8d882.png";